"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Hamburger = _styledComponents["default"].button.attrs(function () {
  return {
    id: "navButton best-nav-hamburger",
    type: "button",
    "data-toggle": "collapse",
    "data-target": "#navbarSupportedContent",
    "aria-controls": "navbarSupportedContent",
    "aria-expanded": "false",
    "aria-label": "Toggle navigation"
  };
}).withConfig({
  displayName: "NavHamburger__Hamburger",
  componentId: "sc-1d3qx2h-0"
})(["&&&{border:none;background:transparent;z-index:1055;&:focus{&&&{outline:none;background:transparent;}}&:hover > .icon-bar:nth-child(2){width:30px;transition:ease all 0.2s;}&:active > .icon-bar:nth-child(2){width:30px;transition:ease all 0.2s;}&:not(.mobile-nav-closed) .icon-bar:nth-child(1){transform:rotate(45deg) translate(5px,4px);transition:ease all 0.2s;}&:not(.mobile-nav-closed) .icon-bar:nth-child(2){opacity:0;transition:ease all 0.2s;}&:not(.mobile-nav-closed) .icon-bar:nth-child(3){transform:rotate(-45deg) translate(4px,-4px);transition:ease all 0.2s;}.icon-bar{background-color:", ";transform:rotate(0deg) translate(0px,0px);transition:ease all 0.2s;display:block;width:30px;height:2px;border-radius:1px;}.icon-bar + .icon-bar{margin-top:4px;}}"], function (props) {
  return props.color;
});
var NavHamburger = function NavHamburger(_ref) {
  var open = _ref.open,
    toggle = _ref.toggle,
    color = _ref.color;
  var mobileNavClass = open ? "mobile-nav-open" : "mobile-nav-closed";
  return _react["default"].createElement(Hamburger, {
    className: "navbar-toggler navbar-toggler-right custom-toggler pull-left mr-1 ".concat(mobileNavClass),
    onClick: function onClick() {
      return toggle(!open);
    },
    color: color
  }, _react["default"].createElement("span", {
    className: "icon-bar top-bar"
  }), _react["default"].createElement("span", {
    className: "icon-bar middle-bar"
  }), _react["default"].createElement("span", {
    className: "icon-bar bottom-bar"
  }), _react["default"].createElement("span", {
    className: "sr-only"
  }, "Toggle navigation"));
};
NavHamburger.propTypes = {
  open: _propTypes["default"].bool.isRequired,
  toggle: _propTypes["default"].func.isRequired,
  color: _propTypes["default"].string
};
NavHamburger.defaultProps = {
  open: false,
  color: "#ffffff"
};
var _default = NavHamburger;
exports["default"] = _default;